import * as FlagComponents from 'country-flag-icons/react/3x2';
import { cn } from '@/lib/utils';
import getUnicodeFlagIcon from 'country-flag-icons/unicode';

/**
 * Bandeira estável em todos os browsers/OS: SVG do country-flag-icons.
 * Fallback: emoji Unicode (útil se algum código ISO não existir no pacote).
 */
export function CountryFlagSvg({ iso, title, className, size = 'md' }) {
  const key = iso.replace(/-/g, '_');
  const Flag = FlagComponents[key] || FlagComponents[iso];
  const sizeClass =
    size === 'sm'
      ? 'intl-flag-svg--sm'
      : size === 'lg'
        ? 'intl-flag-svg--lg'
        : 'intl-flag-svg--md';

  if (!Flag) {
    let emoji = '🏳️';
    try {
      emoji = getUnicodeFlagIcon(iso);
    } catch {
      /* keep fallback */
    }
    return (
      <span
        className={cn('intl-phone-flag intl-phone-flag--emoji', sizeClass, className)}
        title={title}
        aria-hidden
      >
        {emoji}
      </span>
    );
  }

  return (
    <span className={cn('intl-flag-svg', sizeClass, className)} title={title} aria-hidden>
      <Flag className="intl-flag-svg__img" focusable="false" />
    </span>
  );
}
